'use strict';



function ___$insertStyle(css) {
  if (!css) {
    return;
  }
  if (typeof window === 'undefined') {
    return;
  }

  var style = document.createElement('style');

  style.setAttribute('type', 'text/css');
  style.innerHTML = css;
  document.head.appendChild(style);
  return css;
}

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
require('./styles.scss.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var ICON_CLASSNAME = {
    'lifepal__icon': ['search-child', 'search', 'search-mobile', 'search-mobile-user', 'close', 'login', 'whatsapp', 'whatsapp--white', 'call', 'burger', 'burger--white', 'call-slide', 'whatsapp-slide', 'profiles', 'profiles--white', 'arrow-right-blue', 'arrow-up-small', 'arrow-down-small'],
    'lifepal__login__icon': ['profile', 'help', 'policy', 'request', 'home']
};
var MobileNavigation = function (props) {
    var menus = props.menus, onClick = props.onClick, active = props.active;
    var _a = React.useState(''), isActive = _a[0], setIsActive = _a[1];
    var onMenuClick = function (link, slug) {
        setIsActive(slug);
        onClick(link);
    };
    React.useEffect(function () {
        if (active) {
            setIsActive(active);
        }
    }, [active]);
    return (React__default['default'].createElement("div", { className: "mobile-navigation-container" },
        React__default['default'].createElement("div", { className: "mobile-navigation-menus" }, menus.map(function (nav) {
            var iconV = '';
            Object.keys(ICON_CLASSNAME).forEach(function (name) {
                if (ICON_CLASSNAME[name].find(function (thisClass) { return thisClass === nav.icon; })) {
                    iconV = name;
                }
            });
            return (React__default['default'].createElement("button", { onClick: function () { onMenuClick(nav.link, nav.slug); }, type: "button", className: "navigation-menu" },
                React__default['default'].createElement("i", { className: iconV + " " + iconV + "--" + nav.icon + (isActive === nav.slug ? '--active' : '') }),
                React__default['default'].createElement("span", { className: isActive === nav.slug ? 'active' : '' }, nav.label)));
        }))));
};

exports.MobileNavigation = MobileNavigation;
//# sourceMappingURL=index.js.map
